import $ from "jquery";

require('@accessible360/accessible-slick')

let setHistorySlider = () => {
  $('.js-slider--images').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.js-slider--dots',
    dots: false,
    arrows: false,
    centerMode: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1260,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
};

let seHistoryImageSlider = () => {
  $('.js-slider--dots').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.js-slider--images',
    dots: false,
    arrows: true,
    centerMode: false,
    focusOnSelect: true,
    prevArrow: '<div class="slick-prev"><i class="icon-arrow-prev"></i></div>',
    nextArrow: '<div class="slick-next"><i class="icon-arrow-next"></i></div>',
    responsive: [
      {
        breakpoint: 1260,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
            slidesToShow: 1
        }
      }
    ]
  });
};

export default {
    can : true,
    run : () => {
      setHistorySlider()
      seHistoryImageSlider()
    }
};
